<ng-container [formGroup]="formGroupCampaignTypeData">
    <div class="row mt-4">
        <div class="col-12">
            <div class="position-relative mb-4">
                <label class="form-check-label form-check-label--paybee mb-1">Additional Instruction for Auction Winners (For example Delivery and Pickup)</label>
                <mdb-form-control class="mb-4">
                  <app-quill-custom mdbInput formControlName="auctionWinnerInstruct" limit="2048"></app-quill-custom>
                </mdb-form-control> 
            </div>
        </div>
    </div>

    <div class="row justify-content-left mt-4">
        <div class="col">
            <mdb-form-control class="form-fill">
                <mdb-select formControlName="auctionType" class="mdb-select">
                  <mdb-option *ngFor="let auctionType of auctionTypeList" [value]="auctionType.value">{{
                    auctionType.label
                  }}</mdb-option>
                </mdb-select>
                <label mdbLabel class="form-label form-label--paybee">Select Auction Type</label>
            </mdb-form-control>

        </div>
    </div>
    <div class="row" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
        <div class="col-12">
            <app-mdb-switch label="Enable Automatic Bidding Start/Stop" formControlName="auctionControlMethod"></app-mdb-switch>
        </div>
        <div class="w-100" style="padding-left: 44px;" *ngIf="formGroupCampaignTypeData.value.auctionControlMethod">
            <app-datetime
                data-panel="settings"
                dateLabel="Start Date"
                timeLabel="Start Time"
                formControlName="auctionStartTime"
                [myDatePickerOptions]="auctionStartTimeOptions"
                [required]="auctionStartTimeRequired"
                [submitted]="submitted"
            ></app-datetime>
            <app-datetime
                dateLabel="Stop Date"
                timeLabel="Stop Time"
                formControlName="auctionEndTime"
                [myDatePickerOptions]="auctionEndTimeOptions"
                [required]="auctionEndTimeRequired"
                [submitted]="submitted"
            ></app-datetime>
            <span class="error-message body-2" *ngIf="auctionEndTimeControl.errors?.incorrectDate">Stop Date Time cannot be before Start Date Time</span>
        </div>
        <div class="divider w-100"></div>
    </div>

    <div class="row" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
      <div class="col-12">
          <app-mdb-switch label="Enable Automatic Auction Close" formControlName="autoCloseEnabled"></app-mdb-switch>
      </div>
      <div class="w-100" style="padding-left: 44px;" *ngIf="formGroupCampaignTypeData.value.autoCloseEnabled">
          <app-datetime
              data-panel="settings"
              dateLabel="Close Date"
              timeLabel="Close Time"
              formControlName="auctionCloseTime"
              [myDatePickerOptions]="auctionCloseTimeOptions"
              [required]="auctionCloseTimeRequired"
              [submitted]="submitted"
          ></app-datetime>
      </div>
      <div class="divider w-100"></div>
    </div>
  
    <div class="row" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
        <div class="col-12">
            <app-mdb-switch label="Hide Top Bidder to be shown to other bidders" formControlName="hideTopBidder" [disabled]="formGroupCampaignTypeData.value.auctionType === 1"></app-mdb-switch>
        </div>
        <div class="divider w-100"></div>
    </div>
    <div class="row" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
        <div class="col-12">
            <app-mdb-switch label="Show full bid history to the bidders" formControlName="showBidHistory" [disabled]="formGroupCampaignTypeData.value.auctionType === 1"></app-mdb-switch>
        </div>
        <div class="divider w-100"></div>
    </div>
    <div class="row" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
        <div class="col-12">
            <app-mdb-switch label="Disable Auto Bid" formControlName="autoBidDisabled" [disabled]="formGroupCampaignTypeData.value.auctionType === 1"></app-mdb-switch>
        </div>
        <div class="divider w-100"></div>
    </div>

    <div class="row" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
      <div class="col-12 d-flex align-items-center">
        <app-mdb-switch label="Show Best Value Items" formControlName="showBestValueItems" [disabled]="formGroupCampaignTypeData.value.auctionType === 1"></app-mdb-switch>
        <div class="help-icon ml-3">
            <app-text-popover
              placement="bottom"
              type="video-help"
              title="Help"
            >
              <div class="col-12 video-help">
                Switching this ON will display all items with no bids to donors
              </div>
            </app-text-popover>
        </div>
      </div>
      <div class="divider w-100"></div>
    </div>

    <div class="row" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
      <div class="col-12 d-flex align-items-center">
        <app-mdb-switch label="Show Trending Items" formControlName="showTrendingItems" [disabled]="formGroupCampaignTypeData.value.auctionType === 1"></app-mdb-switch>
        <div class="help-icon ml-3">
          <app-text-popover
            placement="bottom"
            type="video-help"
            title="Help"
          >
            <div class="col-12 video-help">
              Switching this ON will display the top five items with most number of bids to donors
            </div>
          </app-text-popover>
        </div>
      </div>
      <div class="divider w-100"></div>
    </div>
    <div class="row" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
      <div class="col-12 d-flex align-items-center">
        <app-mdb-switch label="Show Item Value" formControlName="showItemValue" [disabled]="formGroupCampaignTypeData.value.auctionType === 1"></app-mdb-switch>
        <div class="help-icon ml-3">
          <app-text-popover
            placement="bottom"
            type="video-help"
            title="Help"
          >
            <div class="col-12 video-help">
              Switching this ON will display the value of the item to bidders if set for the auction item.
            </div>
          </app-text-popover>
        </div>
      </div>
      <div class="divider w-100"></div>
    </div>
    <div class="row pb-5 mb-5" *ngIf="formGroupCampaignTypeData.value.auctionType == 0">
      <div class="col-12 d-flex align-items-center">
        <app-mdb-switch label="Donors must login to place bids" formControlName="verifyEmailForBidding" [disabled]="formGroupCampaignTypeData.value.auctionType === 1"></app-mdb-switch>
        <div class="help-icon ml-3">
          <app-text-popover
            placement="bottom"
            type="content"
            text="If switched ON, when a donor tries to place a bid, they will be asked to login using a one-time code sent to their email. This is helpful if you'd like to verify donors' emails."
            title=""
          >
          </app-text-popover>
        </div>
      </div>
      <div class="divider w-100"></div>
      <div class="col-12 d-flex align-items-center">
        <app-mdb-switch label="Donors must save payment info to place bids" formControlName="saveCardRequired" [disabled]="formGroupCampaignTypeData.value.auctionType === 1"></app-mdb-switch>
        <div class="help-icon ml-3">
          <app-text-popover
            placement="bottom"
            type="content"
            text="If switched ON, when a donor tries to place a bid, they will be asked to login using a one-time code sent to their email and then save their payment information. Once the auction closes, the winners can then be charged by admins."
            title=""
          >
          </app-text-popover>
        </div>
      </div>
      <div class="divider w-100"></div>
    </div>

</ng-container>
